import * as constants from '../StoreConstants/TransactConstants';
export const TransactDetails = {
  state: {
    showtransactpopup: false,
    transactsteps: [
      'Payment',
      'Trade-In',
      'Credit Score',
      'Taxes&Fees',
      'Make a Deposit',
      'Check Out'
    ]
  },
  mutations: {
    [constants.SHOW_TRANSACT_POPUP](state, payload) {
      state.showtransactpopup = payload;
    }
  }
};
